<template>
  <div>
    <div class="banner">
      <h4>{{ title }}</h4>
    </div>
  
    <v-form @submit.prevent="create" ref="form"> 
      <v-select
        :items="type_references"
        item-value="id"
        item-text="description"
        class="rounded-lg" 
        color="#41916b"
        outlined 
        v-model="resource.type_reference_id" 
        data-cy="captation-unity-type"
        :rules="formRules" 
        dense>
          <template v-slot:label>
              Tipo de Unidade<span style="color: red;">*</span>
          </template>
      </v-select>

      <v-text-field
        class="rounded-lg" 
        color="#41916b"
        maxlength="50"
        counter="50"
        outlined 
        v-model="resource.description" 
        data-cy="captation-unit-description"
        :rules="formRules" 
        dense>
          <template v-slot:label>
              Nome da Unidade<span style="color: red;">*</span>
          </template>
      </v-text-field>
 
      <v-card-actions class="cardFooter">
        <v-spacer></v-spacer>
          <v-btn class="rounded-lg" color="#e74c3c" text elevation="0" @click="closeDialog()">
            <span>{{$t('buttons.cancel')}}</span>
          </v-btn>

          <v-btn class="rounded-lg" color="blue" text elevation="0" @click="clearForm()">
            <span>{{$t('buttons.clean_up')}}</span>
          </v-btn>

          <v-btn class="rounded-lg" data-cy="save-captation-unit-btn" elevation="0" color="#41916b" type="submit" :loading="loading">
            <span class="textBtn">{{ btnMessage }}</span>
            <v-icon color="#FFFFFF" small class="ml-2">mdi-arrow-right</v-icon>
          </v-btn>
      </v-card-actions>
    </v-form> 
  </div>
</template>
  
<script>
import { saveCaptationUnities } from "@/service/basic-registrations/CaptationUnitiesService"; 
import Formatters from "@/utils/Formatters";
import FormFieldsService from '@/service/FormFieldsService';
import { mapActions } from "vuex";
export default {
  data() {
    return {
        dialog: false, 
        formRules: [(v) => !!v || "Campo obrigatório."],
        displayError: {
          display: false,
          message: [],
        },    
        loading: false,
        options: {}, 
        type_references: []
      };
  },

  props: { 
    resource: {
      type: Object,
    }
  }, 

  watch: {
    resource: {
      handler() {
        if (!this.resource.id) {
          this.$refs.form?.resetValidation();
        }
      },
      immediate: true,
    }
  },

  computed: {
    title() {
      return this.resource.id ? "Atualizar Unidade Captadora" : "Nova Unidade Captadora";
    },

    btnMessage() {
      return this.resource.id ? "Atualizar" : "Salvar";
    },
  },

  async mounted(){
    this.type_references = await FormFieldsService.getTypeReferences()
  },

  methods: {
    ...mapActions([
      "changeSnackBarData", 
    ]),
    
    create() { 
      if(this.$refs.form.validate()) { 
        this.loading = true;

        const isEdit = !!this.resource.id; 
        const dados = {
          ...this.resource,
          description: this.resource.description.toUpperCase(),
          type_reference_id: this.resource.type_reference_id
        };

            saveCaptationUnities(isEdit ? this.resource.id : null, dados).then((response) => {
              this.loading = false; 
              this.changeSnackBarData({
                status: true,
                type: "success",
                titleMessage: response.data.message,
                bodyMessage: "",
                cardColor: "#41916b",
                titleIcon: "mdi-checkbox-marked-circle",
              });

              setTimeout(() => {
                this.closeDialog();
                this.closeSnackBar();
              }, 3000); 
          }).catch((err) => {
            this.loading = false;
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: "Algo deu errado!",
              bodyMessage: Formatters.formatErrorMessage(err),
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            })

            setTimeout(() => {
              this.closeSnackBar();
            }, 3000);
          });   
      }
    },

    clearForm(){
      this.$refs.form.resetValidation();
      this.$refs.form.reset(); 
    },

    closeDialog() {
        this.$emit("closeDialog");
        this.clearForm(); 
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    } 
  }, 
};
</script>
  
<style scoped> 
.space {
  width: 15px;
} 
 
.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}
 
.card {
  padding: 35px;
}

.banner {
  background: #b3ffab; 
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c); 
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd); 

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner>h4 {
  color: #ffffff;
  padding: 10px;
}

.cardFooter {
  padding: 0 !important;
}
</style>
  